import { useMemo } from 'react';
import { type ListDropdownItem } from '@sr/types';

import { Dropdown, SimpleSelectList } from '../Dropdown';
import { MobileStyle, SegmentButton, SegmentWrapper } from './styles';

export type SegmentedButtonsProps = {
  items: SegmentButtonType[];
  selectedValue?: string;
  onChange: (value: string) => void;
};

export type SegmentButtonType = {
  value: string;
  label: string;
  onClick?: () => void;
  testId?: string;
};

export const SegmentedButtonsV2 = ({ items, selectedValue, onChange }: SegmentedButtonsProps) => {
  const dropDownItems = useMemo((): ListDropdownItem[] => {
    return items.map((item) => {
      return {
        ...item,
        type: 'value',
        children: [],
      };
    });
  }, [items]);

  return (
    <>
      <SegmentWrapper aria-label="Segmented Buttons">
        {items.map((item) => (
          <SegmentButton
            key={item.value}
            isSelected={selectedValue === item.value}
            onClick={() => {
              onChange(item.value);
            }}
            data-testid={item.testId || `segmentedButton-${item.value}`}
            type="button"
            aria-pressed={selectedValue === item.value}
          >
            {item.label}
          </SegmentButton>
        ))}
      </SegmentWrapper>
      <MobileStyle>
        <Dropdown
          items={dropDownItems}
          onChange={(value) => {
            onChange(value[0]);
          }}
          selectedValues={selectedValue ? [selectedValue] : []}
          placeholder=""
          multiSelect={false}
          data-testid="segmented-buttons-dropdown"
        >
          <SimpleSelectList />
        </Dropdown>
      </MobileStyle>
    </>
  );
};
